<template>
  <responsive-modal v-model="visible" title="Integrar eNotas">
    <div class="tool-modal-enotas">
      <a href="https://enotas.com.br/" target="_blank" class="integration-link">
        Conheça o eNotas
        <i class="ph ph-arrow-square-out" />
      </a>
      <action-dispatcher
        action="integration/getCoproducerProducts"
        :parameters="{ limit: 500 }"
      >
        <snow-select
          id="product-select"
          v-model="form.product_id"
          label="Produto"
          :disabled="form.id != null"
          :errors="errors.product_id"
          :options="
            coproducerProducts.map(product => ({
              id: product.product_id,
              name: product.product_name
            }))
          "
        />
      </action-dispatcher>
      <snow-input
        id="token"
        label="Token"
        v-model="form.token"
        :errors="errors.token"
      />
      <snow-select
        id="select-send-invoice"
        label="Quando enviar notas:"
        v-model="form.when_generate_nfe"
        :options="nfeOptions"
        :errors="errors.when_generate_nfe"
      />
      <snow-switch
        id="switch-send-nfe"
        v-model="form.send_nfe_for_client"
        label="Enviar nota para o cliente?"
        :errors="errors.send_nfe_for_client"
      />
      <snow-switch
        id="is_split"
        v-model="form.is_split"
        label="Divisão de notas ao coprodutor?"
        :errors="errors.is_split"
      />
      <div class="snow-submit-buttons mt-3">
        <snow-button
          size="lg"
          class="order-lg-1"
          :disabled="!isValid"
          @click="submit"
          text="Salvar"
        />
        <snow-button
          size="lg"
          text="Cancelar"
          variant="gray"
          class="order-lg-0 order-1"
          @click="
            visible = false;
            clear();
          "
        />
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import documentValidation from "@/mixins/documentValidation";
import { mapState } from "vuex";
export default {
  mixins: [documentValidation],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(
        [
          "product_id",
          "token",
          "when_generate_nfe",
          "send_nfe_for_client",
          "is_split"
        ],
        {
          send_nfe_for_client: false,
          is_split: false
        }
      ),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      } else {
        this.validateCNPJ();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...v
        };
      }
    }
  },
  computed: {
    ...mapState("integration", ["coproducerProducts"]),
    isValid() {
      return (
        this.form.product_id &&
        this.form.token &&
        this.validDocument &&
        this.form.when_generate_nfe !== undefined // necessário comparar com undefined porque o valor pode ser "0"
      );
    },
    nfeOptions() {
      return [
        { id: "0", name: "Emitir nota no ato da venda" },
        { id: "1", name: "Emitir nota depois quando garantia acabar" },
        { id: "2", name: "Não emitir a nota" }
      ];
    }
  },
  methods: {
    clear() {
      this.form = {
        send_nfe_for_client: false,
        is_split: false
      };
      this.$emit("clear-edit");
    },
    onSubmit() {
      this.loading = false;
      this.visible = false;
      this.$emit("update-list");
    },
    submit() {
      this.loading = true;
      let data = { ...this.form };
      let action = this.integrationToEdit
        ? "integration/putIntegration"
        : "integration/postIntegration";
      this.$store
        .dispatch(action, data)
        .then(() => {
          this.$message.success("Integração salva");
          this.onSubmit();
        })
        .catch(error => {
          this.$message.error("Erro ao salvar integração");
          this.errors = error.response.data;
          this.loading = false;
        })
        .finally(() => {});
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-enotas {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
